import { Link, useLocation } from "react-router-dom";
import SiteNavbar from "@/components/feature/SiteNavbar";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteNavbar />

      <main className="flex flex-1 items-center justify-center px-4 pt-20 pb-16">
        <div className="mx-auto w-full max-w-lg text-center">
          <p className="font-heading text-[5rem] font-extrabold leading-none tracking-tight text-primary-500 md:text-[7rem]">
            404
          </p>
          <h1 className="mt-3 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
            这个页面还没有内容
          </h1>
          <p className="mt-2 text-sm leading-7 text-foreground-600">
            你访问的地址可能已经变更，或者这个页面还没有被创建。
          </p>
          <p className="mt-3 inline-block max-w-full truncate rounded-md bg-background-100 px-3 py-1.5 font-mono text-xs text-foreground-500">
            {location.pathname}
          </p>
          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-home-4-line" />
              回到首页
            </Link>
            <Link
              to="/category"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-compass-3-line" />
              浏览动漫分类
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-3 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              <i className="ri-search-line" />
              搜索动漫
            </Link>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}